<template>
	<div class="pages">
		<section class="data-cont">
			<h3 class="fx fx-x-between fx-y-center">
				<div class="fx">
					<p>会员卡统计</p>
					<div class="question-cont">
						<i class="icon-question "></i>
						<div class="question-explain">
							<h5>领取人数</h5>
							<p>领取了会员卡的用户人数</p>
							<h5>使用人数</h5>
							<p>使用了会员卡的总人数</p>
							<h5>使用次数</h5>
							<p>使用会员卡进行付款的总次数</p>
							<h5>优惠金额</h5>
							<p>通过使用会员卡支付所减少的总金额</p>
						</div>
					</div>
				</div>
				<div>
					<div class="fx fx-wrap m-l-10">
						<el-date-picker
						  v-model="params.orderTime"
					      type="daterange"
					      align="right"
					      placeholder="选择日期范围(默认所有)"
					      :picker-options="pickerOptions"
					      @change="handleInit">
					    </el-date-picker>
					</div>
				</div>
			</h3>
			<div class="member-cont">
				<div class="member-data">
					<ul class="fx text-center">
						<li class="fx-fill">
							<strong>{{result.get_count}}</strong>
							<p>领取人数（单位/人）</p>
						</li>
						<li class="fx-fill">
							<strong>{{result.use_person_count}}</strong>
							<p>使用人数（单位/人）</p>
						</li>
						<li class="fx-fill">
							<strong>{{result.use_count}}</strong>
							<p>使用次数（单位/次）</p>
						</li>
						<li class="fx-fill">
							<strong>{{result.fee | filterMoney}}</strong>
							<p>优惠金额（单位/元）</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1100px);
		}
	}
</style>
<script>
	import { mapState, mapActions } from 'vuex';
	export default {
		name: 'VipStatistics',
		components: {},
		data() {
			return {
				columns: ['统计日期', '浏览人数', '浏览次数', '领取人数', '领取次数', '使用人数', '使用次数', '实收金额'],
				result: {
					get_count: 0,
					use_person_count: 0,
					use_count: 0,
					fee: 0
				},
				params: {
					orderTime: ''
				},
				pickerOptions: {
		          shortcuts: [{
		            text: '最近7天',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近15天',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近30天',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		              picker.$emit('pick', [start, end]);
		            }
		          }]
		        }
			}
		},
		mounted() {
			this.handleInit();
		},
		methods: {
//			handleInit() {
//				this.membershipStatics(this.params).then((data)=>{
//					this.result = data;
//				},(msg)=>{
//					this.$toast(msg);
//				})
//			},
//			
//			...mapActions(['membershipStatics']),
		}
	}
</script>


// WEBPACK FOOTER //
// VipStatistics.vue?160b46a2